import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FOOTER_PROXIMITY_PX = 100;

function isNearFooter() {
  const { scrollY, innerHeight } = window;
  const { scrollHeight } = document.documentElement;
  return scrollY + innerHeight >= scrollHeight - FOOTER_PROXIMITY_PX;
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;

    const scrollToTopIfNeeded = () => {
      if (window.scrollY > 0 || isNearFooter()) {
        window.scrollTo({ top: 0, left: 0 });
      }
    };

    scrollToTopIfNeeded();
    const rafId = requestAnimationFrame(scrollToTopIfNeeded);
    return () => cancelAnimationFrame(rafId);
  }, [pathname, hash]);

  return null;
}
